import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.bereich-trigger-entfernen';
import * as api from '../../../clients/displaysteuerung';

@Injectable()
export class DisplaysteuerungBereichTriggerEntfernenEffects {

    BereichTriggerEntfernen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_BEREICH_TRIGGER_ENTFERNEN),
        mergeMap((x: ac.PostBereichTriggerEntfernenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postBereichTriggerEntfernen(x.bereichTriggerRequest).pipe(
                map((result: any) => {
                    return new ac.PostBereichTriggerEntfernenErfolgreichAction(result, x.bereichTriggerRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostBereichTriggerEntfernenFehlerAction(error, x.bereichTriggerRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.VerwaltenCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.VerwaltenCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.VerwaltenCommandService);
        }
        return this.service;
    }
}
